/**
 * Sistem durumu saga — V2 Faz F.
 * Backend: Komut.Rentificial.Application/Controllers/Admin/Status/SystemStatusController.cs
 */
import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";

import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";

import { StatusOverview } from "./type";

export const getStatusOverview = createAction(
  "GET_SYSTEM_STATUS",
  ({ payload }: SagaActionParams<StatusOverview>) => ({
    payload,
    url: "/api/status",
  })
);

export const setComponentStatus = createAction(
  "SET_COMPONENT_STATUS",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/status/components/" + id,
  })
);

export const createIncident = createAction(
  "CREATE_SYSTEM_INCIDENT",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/status/incidents",
  })
);

export const updateIncidentStatus = createAction(
  "UPDATE_SYSTEM_INCIDENT",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/status/incidents/" + id + "/status",
  })
);

const systemStatusSaga = [
  takeLatest<any>(getStatusOverview.toString(), (p: SagaGenericParams<StatusOverview>) =>
    getSaga<StatusOverview>(p)
  ),
  takeLatest<any>(setComponentStatus.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(createIncident.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(updateIncidentStatus.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default systemStatusSaga;
